export default "__VITE_ASSET__j_VOd7dx__"